import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "semantic-ui-react";

import { useBooleanState } from "hooks";
import DatePickerInput from "components/DatePickerInput";
import Popper from "components/Popper";

const PureNewTaskReminder = ({
  taskTitle,
  title,
  overdueInfo,
  hasReminder,
  selectedDate,
  setSelectedDate,
  saveReminder,
}) => {
  const [reminderPopupOpen, setReminderPopupOpen] = useState(false);
  const [inputDateError, setError, clearError] = useBooleanState();

  return (
    <Popper
      on="click"
      open={reminderPopupOpen}
      onClose={() => {
        setReminderPopupOpen(false);
      }}
      onOpen={() => {
        setReminderPopupOpen(true);
      }}
      offset="-12"
      trigger={
        hasReminder ? (
          <Icon
            color={overdueInfo.iconColor}
            link
            name="bell"
            onClick={() => {
              setReminderPopupOpen(true);
            }}
            title={title}
            data-test={`task-reminder-trigger-${taskTitle}`}
          />
        ) : (
          <Icon.Group
            className={
              !reminderPopupOpen ? "show_on_hover dark_grey_on_hover" : ""
            }
            onClick={() => {
              setReminderPopupOpen(true);
            }}
            style={{ fontSize: "13pt" }}
            title="Reminder"
            data-test={`task-reminder-trigger-${taskTitle}`}
          >
            <Icon
              link
              name="bell outline"
              style={
                reminderPopupOpen
                  ? { color: "#aaaaaa", margin: 0 }
                  : { margin: 0 }
              }
            />
            <Icon
              link
              corner
              name="add"
              style={
                reminderPopupOpen
                  ? { color: "#aaaaaa" }
                  : { color: "#aaaaaa", textShadow: "none" }
              }
            />
          </Icon.Group>
        )
      }
    >
      <div style={{ width: "max-content" }} data-test="schedule-reminder-popup">
        <DatePickerInput
          defaultDate={selectedDate}
          onChange={(d) => {
            if (d) {
              setSelectedDate(d);
              clearError();
            } else {
              setError();
            }
          }}
          showTimeSelect
          dateFormat="Pp"
          inline
          fixedHeight
          showQuickLink
          timeIntervals={30}
        />
        <Button
          disabled={inputDateError}
          fluid
          positive
          onClick={() => {
            saveReminder();
            setReminderPopupOpen(false);
          }}
          style={{ marginTop: "1em" }}
        >
          {hasReminder ? "Save" : "Add"}
        </Button>
      </div>
    </Popper>
  );
};

PureNewTaskReminder.propTypes = {
  taskTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  overdueInfo: PropTypes.object.isRequired,
  hasReminder: PropTypes.bool.isRequired,
  selectedDate: PropTypes.object.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  saveReminder: PropTypes.func.isRequired,
};

export default PureNewTaskReminder;
